import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpServiceMdr } from 'src/app/services/main.service';

@Component({
  selector: 'app-view-device',
  templateUrl: './view-device.component.html',
  styleUrls: ['./view-device.component.scss']
})
export class ViewDeviceComponent implements OnInit {

  revoked = false;
  issueDate:any = [];
  revokeDate:any;
  text:any;
  issuesNote:any;
  revokeNote:any;
  mdrToken:any = null;
  issuerData:any;
  issuerId:any;
  role:any;

  constructor( @Inject(MAT_DIALOG_DATA) 
  public data: any, 
  private snackBar:MatSnackBar,
  private httpServiceMdr : HttpServiceMdr,
  private dialogRef: MatDialogRef<ViewDeviceComponent>,) 
  {
    console.log(this.data);
    this.text = this.data.text;
    this.mdrToken = localStorage.getItem("mdr-token");
    this.role = localStorage.getItem("display-role");
   }

  ngOnInit(): void {
    for(const element of this.data.item){
      if(element.linkId == 'revoke-details') {
        this.revoked = true;
        for(let data of element.answer){
          if(data.valueString) {
            this.revokeNote = data.valueString; 
          }
          if(data.valueDateTime) {
            this.revokeDate = data.valueDateTime;
          }
        }
      }
      if(element.linkId == 'issue-details') {
        for(let data of element.answer){
          if(data.valueString) {
            this.issuesNote = data.valueString; 
          }
          if(data.valueDateTime) {
            this.issueDate = data.valueDateTime;
          }
          if(data.valueReference) {
            this.issuerId = this.getIssuerId(data.valueReference.reference);
            this.getIssuerDetails()
          }
        }
      }
    }
  }

  removeDevice(){
    this.dialogRef.close({ data: 'confirmed' })
 }

 getIssuerId(str:any) {
  return str.split('/')[1];
}

 getIssuerDetails(){
  this.httpServiceMdr.getRequestCall(`Practitioner/`+this.issuerId ,this.mdrToken,{}).subscribe(
    {
     next: (value:any) => { 
     this.issuerData = value.name[0];

     },
     error: (err) => {
      this.errorStatus(err);
     }, 
 });
}


  close(){
    this.dialogRef.close({ data: 'cancelled' })
  }

  errorStatus(error:any){
    this.snackBar.open((error.error.message[0]), '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3 * 1000,
    });
  }

}

